
const FulfillmentTypes = {
  SHIPPABLE: 1, // shipping only
  NONSHIPPABLE: 2,
  PICKUP: 3, // pickup only
  BOTH: 4,
  DIGITALDOWNLOAD: 5
}

export default FulfillmentTypes
